import { generateRequest } from '.';

export const Action = {
  Fuels: {
    ReportPending: 'Report_PENDING',
    ReportCompleted: 'Report_FULFILLED',
    ReportFailed: 'Report_FAILED',
    ReportReset: 'Report_RESET',
  },
};

export const submitPriceReport = (stationId, body) => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: `/assets-v2/api/stations/${stationId}/prices`,
  body,
  types: [
    Action.Fuels.ReportPending,
    Action.Fuels.ReportCompleted,
    Action.Fuels.ReportFailed,
  ],
});

export const resetPriceReportStatus = () => ({
  type: Action.Fuels.ReportReset,
});
